import { parseServerDate } from "./timeUtils";

export const DEADLINE_ACTIVE_STATUSES = ["pending", "open", "discussing", "accepted", "in_progress", "revision_requested"];
export const EXPIRY_CANCEL_STATUSES = ["accepted", "in_progress", "revision_requested"];

// П.3 TZ-6: в механизме сроков участвуют только оплаченные задания и задания от организаций (демо-витрина — нет)
export const deadlineParticipates = (task) => !!task && (task.payment_status === "paid" || !!task.is_b2b);

export const isDeadlineExpired = (task, now = new Date()) => {
  if (!deadlineParticipates(task) || !DEADLINE_ACTIVE_STATUSES.includes(task.status) || !task.deadline) return false;
  const d = parseServerDate(task.deadline);
  return !!d && !isNaN(d) && d <= now;
};

export const canCancelByExpiry = (task) => isDeadlineExpired(task) && EXPIRY_CANCEL_STATUSES.includes(task.status);
